import { Base } from '@models/base.model';
import { PageObject } from '@models/page-object.model';
import { serializable, deserialize } from 'serializr';

export class ByPriorityCount extends Base implements PageObject {
  @serializable
  public priority: number;
  @serializable
  public count: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ByPriorityCount, input));
  }
}
